<script lang="ts">
  import ShimmerBar from './ShimmerBar.svelte';

  // A tela de detalhe não é uma tabela: são quatro cartões e painéis de barras.
  // Usar o esqueleto da tabela aqui fazia a tela trocar de forma ao carregar.
  // Mesma contagem da tela cheia: cinco cartões, seis painéis, e cada barra com
  // a grade de quatro medidas embaixo. O esqueleto com metade da massa fazia a
  // página encolher e voltar a crescer quando o dado chegava.
  const CARTOES = 5;
  const PAINEIS = 6;
  const BARRAS = ['92%', '64%', '38%', '25%'];
  const MEDIDAS = 4;
</script>

<div class="skeleton" aria-busy="true" aria-label="carregando detalhe do custo">
  <div class="head">
    <ShimmerBar width="240px" height={24} />
    <ShimmerBar width="180px" height={12} />
  </div>

  <div class="cards">
    {#each Array(CARTOES) as _, i (i)}
      <div class="card">
        <ShimmerBar width="52%" height={11} />
        <ShimmerBar width="66%" height={26} />
        <ShimmerBar width="38%" height={11} />
      </div>
    {/each}
  </div>

  <div class="panels">
    {#each Array(PAINEIS) as _, painel (painel)}
      <section class="panel">
        <ShimmerBar width="140px" height={13} />
        {#each BARRAS as largura, barra (barra)}
          <div class="bar">
            <div class="bar-head">
              <ShimmerBar width="45%" height={12} />
              <ShimmerBar width="70px" height={12} />
            </div>
            <ShimmerBar width={largura} height={6} />
            <div class="metrics">
              {#each Array(MEDIDAS) as _, medida (medida)}
                <div class="metric">
                  <ShimmerBar width="70%" height={9} />
                  <ShimmerBar width="52%" height={15} />
                  <ShimmerBar width="60%" height={9} />
                </div>
              {/each}
            </div>
          </div>
        {/each}
      </section>
    {/each}
  </div>
</div>

<style>
  .skeleton {
    display: flex;
    flex-direction: column;
    gap: var(--space-5);
  }
  .head {
    display: flex;
    flex-direction: column;
    gap: var(--space-2);
  }
  .cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: var(--space-4);
  }
  .card,
  .panel {
    background: var(--bg-elevated);
    border: 1px solid var(--border-subtle);
    border-radius: var(--radius-md);
    padding: var(--space-4);
    display: flex;
    flex-direction: column;
    gap: var(--space-3);
  }
  .panels {
    columns: 3 340px;
    column-gap: var(--space-4);
  }
  .panels > .panel {
    break-inside: avoid;
    margin-bottom: var(--space-4);
  }
  .bar {
    display: flex;
    flex-direction: column;
    gap: var(--space-2);
  }
  .bar-head {
    display: flex;
    justify-content: space-between;
    gap: var(--space-3);
  }
  .metrics {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: var(--space-2);
    padding-top: var(--space-2);
    border-top: 1px solid var(--border-subtle);
  }
  .metric {
    display: flex;
    flex-direction: column;
    gap: 3px;
    min-width: 0;
  }
</style>
